import { FileType } from '../../types/files';

/** Возвращает тип аттача по mime-типу файла */
export const getFileType = (type: string): FileType => {
  if (type.includes('image/')) {
    return FileType.Image;
  } else {
    return FileType.File;
  }
};
